import { createReducer } from '@reduxjs/toolkit';
import { handleActionStart, handleActionError } from 'store/utils';
import {
  setCurrentPatient,
  clearCurrentPatient,
} from 'store/currentPatient/actions';

import { fetchFhirProcedures } from 'store/currentPatient/actions/fhir';

const initialState = {
  data: [],
  isLoading: false,
  error: null,
};

export default createReducer(initialState, {
  [fetchFhirProcedures.STARTED]: handleActionStart,
  [fetchFhirProcedures.SUCCEEDED]: (state, action) => {
    state.isLoading = false;
    state.error = null;
    state.data = action.payload;
  },
  [fetchFhirProcedures.FAILED]: handleActionError,
  [setCurrentPatient]: (_, action) => action.payload.procedures,
  [clearCurrentPatient]: () => initialState,
});
